<template>
    <div :class="[{[$style.box]: id == null}, {[$style.severity]: id == 'severity'}]">
        <transition name="slide-fade">
            <!-- <div v-if="userBadge" class="badge user"/> -->
            <badge style="position:absolute; top:5px; left:5px;" v-if="userBadge" :badgeType="'user'"/>
        </transition>

        <transition name="slide-fade">
            <!-- <div v-if="facultyBadge" class="badge faculty"/> -->
            <badge style="position:absolute; top:5px; right:5px;" v-if="facultyBadge" :badgeType="'faculty'"/>
        </transition>

        {{label}}
        <!-- <v-btn fab small style="position:absolute; bottom: 0px; left: 0px;" color="teal" @click="$emit('testBox',{type:'user',severity:severity,state:state})">test</v-btn> -->
        <!-- <v-btn fab small style="position:absolute; bottom: 0px; right: 0px;" color="warning" @click="$emit('testBox',{type:'faculty',severity:severity,state:state})">test</v-btn> -->
    </div>
</template>

<script>
import badge from './assets/badge.vue';

export default {
    props: {
        userBadge: {
            type: Boolean,
            required: false,
            default: false
        },
        facultyBadge: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        severity: {
            type: String,
            required: true
        },
        state: {
            type: Number,
            required: true
        },
        id: {
            type: String,
            required: false,
            default: null
        }
    },
    components: {
        badge
    }
}
</script>

<style module>
.severity{
    position: relative;
    color: white;
    font-weight: 300;
    width: 80%;
    border-radius: 5px;
    padding: 3px;
    /* height: 50px; */
    background-color: #66ACDA;
    font-size: 20px;
    margin: 0 auto;
    text-align: center;
}

.box{
    position: relative;
    font-weight: bold;
    font-size: 16px;
    color: black;
    width: 250px;
    /* height: 150px; */
    border: 2px solid #66ACDA;
    margin: 5px auto;
    border-radius: 5px;
    padding: 30px 20px;
    /* padding-top: 12%; */
    text-align: center;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: linear;
    transition-delay: 0s;   
}
</style>


<style scoped>
</style>